import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import piniaPersist from 'pinia-plugin-persist';
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/js/bootstrap.min.js";
import VueAwesomePaginate from "vue-awesome-paginate";

// pinia�̉i����
const pinia = createPinia();
pinia.use(piniaPersist);

const app = createApp(App)
    .use(router)
    .use(pinia)
    .use(VueAwesomePaginate);

// �L���b�`����Ȃ��G���[�̃n���h�����O�ݒ�
app.config.errorHandler = (err, vm, info) => {
    console.error(`errorHandler: ${info}`, err)
    // 500�y�[�W�֑J�ڂ���
    router.replace({ name: 'InternalError' })
}

app.mount('#app')

